<form #groupCategoryform="ngForm" autocomplete="off" *ngIf="categoryGroups && categories">
    <app-dnd-group-categories [categories]="categories" [initialCategoryGroups]="categoryGroups" (categoryGroupsToEmit)="setCategoryGroups($event)">
    </app-dnd-group-categories>
</form>
